import { useContext } from 'react';
import { WorkflowContext } from '../contexts';
import { useModal } from '../contexts';
import { Transition } from '@headlessui/react';
import WorkflowOverviewBlockDocument from './WorkflowOverviewBlockDocument';
import WorkflowOverviewBlockPlaceholder from './WorkflowOverviewBlockPlaceholder';
import WorkflowSelectModal from './WorkflowSelectModal';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  contentOffset: number;
  show: boolean;
}

function WorkflowOverviewSignatureOnly(props: Props) {
  const { contentOffset } = props;
  const { t } = useTranslation();

  const { openModal } = useModal();

  const workflowContext = useContext(WorkflowContext);
  const { workflow } = workflowContext;

  function handleAddBlock() {
    openModal(<WorkflowSelectModal title={t("Add Workflow Block")} subtitle={t("Add a new block to your workflow")} showDocuments workflowContext={workflowContext} />);
  }

  let documents: JSX.Element | null = null;
  if (workflow.documents.length > 0)
    documents = (
      <div className='flex flex-col items-center'>
        {workflow.documents.map((d, index) => (
          <React.Fragment key={d.id}>
            <WorkflowOverviewBlockDocument key={d.id} block={d} index={index} disableDelete />
          </React.Fragment>
        ))}
      </div>
    )
  else if (workflow.documents.length === 0 && workflow.emails.length === 0)
    documents = (
      <div className="flex flex-col items-center">
        <WorkflowOverviewBlockPlaceholder text={t("Add template")} onClick={() => handleAddBlock()} />
      </div>
    );

  return (
    <div className={`relative flex ${!props.show ? "hidden" : ""}`} style={{ height: `calc(100vh - 56px - ${contentOffset}px)` }}>
      <Transition show={props.show} className="flex flex-col items-center flex-1 p-8 pb-20 overflow-auto h-full">
        {documents}
      </Transition>
    </div>
  );
}

export default WorkflowOverviewSignatureOnly;
